import { render, staticRenderFns } from "./HistoryApprovalTasks.vue?vue&type=template&id=79e3ce35&scoped=true"
import script from "./HistoryApprovalTasks.vue?vue&type=script&lang=js"
export * from "./HistoryApprovalTasks.vue?vue&type=script&lang=js"
import style0 from "./HistoryApprovalTasks.vue?vue&type=style&index=0&id=79e3ce35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e3ce35",
  null
  
)

export default component.exports